import { Box, Grid, Paper, Typography, IconButton } from '@mui/material'
import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import ComboBox from '../../DevComponents/ComboBox'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import { MensagemTipo } from '../../GlobalStates/MensagemState'
import { RespostaPadraoInterface } from '../../ImportBackend/Interfaces/PadraoInterfaces'
import BackEndAPI from '../../Services/BackEndAPI'
import CloseIcon from '@mui/icons-material/Close'
import { ClienteInterface } from '../../ImportBackend/Interfaces/ClienteInterfaces'

export default function SetCliente () {

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto
  const { loginState, setLoginState } = contexto

  const [disable, setDisable] = useState( false )

  const [rsClientes, setRsClientes] = useState<Array<ClienteInterface>>( [] )

  const clsApi: BackEndAPI = new BackEndAPI()

  const navigate = useNavigate()

  const btFechar = () => {
    navigate( '/' )
  }

  const setCliente = ( rsCliente: ClienteInterface ) => {

    const idCliente: number = rsCliente && rsCliente.idCliente && rsCliente.idCliente !== 0 ? rsCliente.idCliente : 0

    if ( idCliente !== 0 ) {

      setDisable( true )

      const mutation = `
        setUsuarioCliente(idCliente: ${idCliente}) {
          ok
          mensagem
        }
      `

      clsApi.mutation<RespostaPadraoInterface>( mutation, 'setUsuarioCliente', 'Alterando Cliente...', contexto ).then( rs => {

        if ( rs.ok ) {
          setLoginState( { ...loginState, idClienteAtual: idCliente } )
          setDados( { idCliente: idCliente } )
          setDisable( false )
        } else {
          setDisable( false )
          setLoginState( { ...loginState, idClienteAtual: 0 } )
        }

      } ).catch( () => {

        setMensagemState( {
          ...mensagemState,
          titulo: 'Erro! Consulte Suporte!',
          exibir: true,
          mensagem: 'Erro ao Alterar Cliente do Usuário!',
          tipo: MensagemTipo.Error,
          exibirBotao: true
        } )

        setDisable( false )

      } )

    }

  }

  const pesquisarUsuarioClientes = () => {
    const query = `
      getUsuarioClientesPermitidosPorAcesso {
        idCliente
        razaoSocial
        nomeFantasia
      }
    `

    clsApi.query<Array<ClienteInterface>>( query, 'getUsuarioClientesPermitidosPorAcesso', 'Recebendo Clientes...', contexto ).then( rsClientes => {

      setRsClientes( rsClientes )

      if ( rsClientes.length === 1 ) {
        setCliente( rsClientes[0] )
      }

    } ).catch( () => {

      setMensagemState( {
        ...mensagemState,
        titulo: 'Erro! Consulte Suporte!',
        exibir: true,
        mensagem: 'Erro ao Consultar Clientes de Usuários!',
        tipo: MensagemTipo.Error,
        exibirBotao: true
      } )

    } )

  }

  useEffect( () => {

    pesquisarUsuarioClientes()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )

  const [dados, setDados] = useState( { idCliente: 0 } )

  return (
    <>

      <Grid
        container
        justifyContent='center'
        alignItems='center'
        height='50vh'
      >
        <Grid item xs={10} sm={8} md={6} lg={4}>
          <Paper>

            <Box
              sx={{ backgroundColor: 'white', padding: 2, mx: 5 }}
            >
              <Grid>
                <Grid item textAlign='right'>
                  <IconButton onClick={() => btFechar()}>
                    <CloseIcon />
                  </IconButton>
                </Grid>


                <Grid item textAlign='center'>
                  <Typography variant="h5" fontFamily='sans-serif' fontWeight='bolder' color="primary.main">
                    Selecione uma Empresa
                  </Typography>
                </Grid>

                <Grid item xs={12}>

                  <ComboBox
                    campoDescricao='nomeFantasia'
                    campoID='idCliente'
                    opcoes={rsClientes}
                    dados={dados}
                    field='idCliente'
                    label='Acessar Dados de:'
                    setState={setDados}
                    onChange={( v: ClienteInterface ) => { setCliente( v ); btFechar() }}
                    disabled={disable}
                  />

                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Grid>
      </Grid>

    </>
  )

}